function Logo() {
  return <span className="pl-logo-text ml-3 z-50">RS.</span>;
}

export default Logo;
